import { useQuery } from 'react-query'

import { Vendor } from '@webapp/modules/vendor/entities/Vendor'
import { vendorQueryConfig } from '@webapp/modules/vendor/query-configs/vendor'

// Reuses the vendor domain's existing repository + query key (ADR-6/8 —
// no reports-local config for cross-module fetches). `enabled` lets the
// config-driven detail FS call all three header hooks unconditionally
// (rules-of-hooks) while fetching only its own config's entity.
export const useQueryVendorDetailHeader = (
  vendorId: number,
  enabled = true
) => {
  const { data, isFetching } = useQuery({
    ...vendorQueryConfig.getVendor(vendorId),
    enabled,
  })

  return {
    vendor: data ? new Vendor(data.data) : null,
    isLoading: isFetching,
  }
}
